import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from 'common/react/components/SvgIcon';

export const BroadcasterItem = ({ broadcaster }) => {
    const broadcasterName = broadcaster.name.toLowerCase().replace(' ', '-');

    let icon = `broadcaster-${broadcasterName}`;

    return (
        <>
            {broadcaster.showNormal ? (
                <div className="fixtures__broadcaster-item">
                    <SvgIcon
                        icon={icon}
                        className={`fixtures__broadcaster-logo fixtures__broadcaster-logo--${broadcasterName}`}
                        folder="elements"
                        subfolder="broadcaster"
                    />
                </div>
            ) : null}
            {broadcaster.showDelayed ? (
                <div className="fixtures__broadcaster-item">
                    <SvgIcon
                        icon={icon + '-delayed'}
                        className={`fixtures__broadcaster-logo fixtures__broadcaster-logo--${broadcasterName}-delayed`}
                        folder="elements"
                        subfolder="broadcaster"
                    />
                </div>
            ) : null}
        </>
    );
};

BroadcasterItem.propTypes = {
    broadcaster: PropTypes.object.isRequired
};
